export const BLOOD_TYPE_ABO_OPTIONS = [
  'A+',
  'A-',
  'B+',
  'B-',
  'AB+',
  'AB-',
  'O+',
  'O-',
] as const;

export const BLOOD_TYPE_UNKNOWN = 'Não sei';

export const BLOOD_TYPE_SELECT_OPTIONS = [
  ...BLOOD_TYPE_ABO_OPTIONS,
  BLOOD_TYPE_UNKNOWN,
] as const;

export type BloodTypeAbo = (typeof BLOOD_TYPE_ABO_OPTIONS)[number];
export type BloodTypeSelectValue = (typeof BLOOD_TYPE_SELECT_OPTIONS)[number] | '';
